<template>
  <div class="policyMatching">
    <a-tabs v-model="activeName">
      <a-tab-pane tab="政策匹配" key="policyMatching" />
    </a-tabs>
    <h1>扶持政策报告</h1>
    <div class="enter_input">
      <a-select show-search v-model="value" :autoClearSearchValue="false" :default-active-first-option="false"
        :show-arrow="false" :filter-option="false" :not-found-content="optionLoading ? undefined : null"
        placeholder="请输入企业全称或老板姓名" @search="handleSearch" @focus="handleFocus" @blur="handleBlur" @change="handleChange">
        <a-spin v-if="optionLoading" slot="notFoundContent" size="small" />
        <a-select-option v-for="(company, index) in companyData" :key="index" :value="company">
          {{ company }}
        </a-select-option>
      </a-select>
      <a-button slot="enterButton" :loading="loading"
        style="background: #1890ff; color: #fff; font-weight: 500; height: 50px" @click="report">
        生成扶持政策报告
      </a-button>
    </div>

    <div class="advantage">
      <div class="adv-title">了解企业政策的六大好处</div>
      <div class="triangle" />
      <div class="adv-box">
        <div class="adv-box1 mgb">
          <div class="text">
            <p class="des1">税收政策</p>
            <p class="des2">享受国家税收优惠</p>
          </div>
          <div class="text">
            <p class="des1">优先上市</p>
            <p class="des2">为上市奠定了良好的基础</p>
          </div>
          <div class="text">
            <p class="des1">政策补贴</p>
            <p class="des2">享受国家财政补贴</p>
          </div>
        </div>
        <div class="adv-box1">
          <div class="text">
            <p class="des1">定位明确</p>
            <p class="des2">利于企业宣传，树立品牌形象</p>
          </div>
          <div class="text">
            <p class="des1">产品竞争力</p>
            <p class="des2">提升企业核心产业</p>
          </div>
          <div class="text">
            <p class="des1">招商引资</p>
            <p class="des2">助力企业融资</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import { getCompanyName } from "@/api/policyMatching";
export default {
  data: () => ({
    activeName: "policyMatching",
    companyData: [], // 公司名称
    value: '',
    loading: false,
    optionLoading: false,
    isSearch: false,
  }),
  created() {
    this.value = decodeURI(sessionStorage.getItem("corp") || "").trim();
    if (this.value != "") this.isSearch = true
  },
  methods: {
    handleFocus() {
      this.value = ''
    },
    handleBlur(value) {
      if (value) {
        this.value = value;
      }
    },
    handleChange(value) {
      // this.value = (!isNaN(value) && value != '') ? this.companyData[value] : value
      if (value) {
        this.isSearch = true;
      }
      Object.assign(this, {
        value,
        companyData: [],
        optionLoading: false,
      });
    },
    handleSearch(value) {
      this.optionLoading = true;
      this.value = value;
      let data = {
        name: value,
      };
      getCompanyName(data)
        .then((res) => {
          this.optionLoading = false;
          if (res.data) this.companyData = [...new Set(res.data)];
        })
        .catch((err) => console.log(err));
    },
    // 生成政策报告
    report() {
      if (!this.value) {
        this.$message.warning("公司名称不能为空！");
        return;
      }
      if (!this.isSearch) {
        return this.$message.warning("请选择公司");
      }
      this.loading = true;
      let data = {
        companyName: this.value,
      };
      request({
        url: "/report/buildReport/isCompany",
        method: "post",
        data,
      })
        .then((res) => {
          this.loading = false;
          if (res.data) {
            this.isSearch = false;
            this.$router.push({
              path: "/policyGenerate",
              query: {
                targetId: res.data,
              },
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.policyMatching {
  background: #fff;
  height: 100%;
  padding: 20px;
  color: #333;
  font-family: PingFangSC-Medium, PingFang SC !important;

  ::v-deep .ant-tabs-tab-active {
    font-weight: 500;
    color: #333;
    font-size: 16px;
  }

  ::v-deep .ant-tabs-tab {
    padding-top: 0;
  }
}

h1 {
  font-weight: 600;
  font-size: 44px;
  text-align: center;
  padding-top: 120px;
  width: 100%;
  height: auto;
}

.enter_input {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: 100px;
  height: 50px;
  width: 956px;
  flex: 1;
}

.ant-btn {
  width: 171px !important;
  background: #0072f7 !important;
  border-radius: 0;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border: none;
  font-size: 16px;
}

::v-deep .ant-select {
  display: block;
  height: 50px;
  width: 79%;
  border-radius: 0 !important;
  border-right: none;

  .ant-select-selection {
    height: 50px;
    border-radius: 0;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  .ant-select-selection__rendered {
    line-height: 50px;
    font-size: 16px;
  }

  .ant-input {
    height: 50px;
  }
}

.advantage {
  width: 926px;
  margin: 0 auto;
  margin-top: 60px;

  .adv-title {
    height: 16px;
    color: #7ea0c1;
    font: 600 16px/16px PingFangSC-Semibold, PingFang SC;
    margin-bottom: 6px;
  }

  .triangle {
    width: 0;
    height: 0;
    margin-left: 20px;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 9px solid rgba(237, 243, 250, 0.3);
  }

  .adv-box {
    width: 926px;
    height: 170px;
    background: rgba(237, 243, 250, 0.3);
    border-radius: 2px 0px 1px 0px;
    padding: 48px 30px 34px 30px;

    .adv-box1 {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
    }

    .mgb {
      margin-bottom: 10px;
    }

    .text {
      height: 34px;
      width: 200px;

      p {
        margin: 0;
      }

      .des1 {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #666;
        line-height: 14px;
        margin-bottom: 6px;
      }

      .des2 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999;
        line-height: 14px;
      }
    }
  }
}
</style>